module.exports = __webpack_public_path__ + "img/onboarding-page-dark.5d803887.svg";